import moment from 'moment'
import 'moment/locale/bg'
import 'moment/locale/en-gb'
import {useEffect, useRef} from 'react'
import {useAppConfig} from '../context/app/AppContext'
import {getLanguageCode} from '../i18n/LanguageUtils'

const DatePicker = () => {
    const {timezoneId} = useAppConfig()
    const timeRef = useRef(null)
    const dateRef = useRef(null)
    useEffect(() => {
        const updateClock = () => {
            const locale = getLanguageCode() === 'gb' ? 'en' : getLanguageCode()
            if (timeRef.current) {
                timeRef.current.textContent = moment()
                    .tz(timezoneId)
                    .locale(locale)
                    .format('LTS')
            }
            if (dateRef.current) {
                dateRef.current.textContent = moment()
                    .tz(timezoneId)
                    .locale(locale)
                    .format('dddd DD MMM YYYY')
            }
        }

        updateClock() // lần đầu render
        const interval = setInterval(updateClock, 1000)

        return () => clearInterval(interval)
    }, [timezoneId])

    return (
        <div className="flex col-12 flex-column md:flex-row gap-3 md:align-items-center bg-primary border-round-xl p-3">
            <div className="flex col-12 flex-column align-items-center">
                <span
                    ref={timeRef}
                    className="block mb-1 text-3xl font-semibold"></span>
                <span ref={dateRef} className="mt-0 text-xl"></span>
            </div>
        </div>
    )
}

export default DatePicker
